import { atom } from "jotai";
import { create } from "zustand";
import update from 'immutability-helper';
import { get } from "lodash";

export const useShareStore = create((set) => ({
  name: 'share-store',
  shares: {},
}));


//NOTE: if section level set is required, refer to export and reuse improved update flow
export const updateShareData = ({ pageKey, state }) => useShareStore.setState((currentState) => {
  return update(currentState, {
    shares: {
      [pageKey]: {
          $set: state
      }
    }
  });
});


export function useUpdateShare({ pageKey }) {
  const updateData = (state) => {
    updateShareData({ pageKey, state  });
  }
  return {
    updateData,
  }
}

export function useGetShare({ pageKey }) {
  const shareData = useShareStore((state) => state.shares[pageKey]);
  return {
    shareData
  }
}

// without render subscription
export function getShareData({ pageKey }) {
  const store = useShareStore.getState();
  return get(store, ['shares', pageKey], {});
}

